import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DatevWizardState} from '../../+store/datev-wizard.state';
import {DatevWizardGetFirmaState} from './datev-wizard-get-firma.state';
import {FirmaEntitiesSelectors} from '../../../../../store/firma-entities/firma-entities.selectors';


export class DatevWizardGetFirmaSelectors {

  private static readonly _feature = createFeatureSelector<DatevWizardState>('wizard');

  private static readonly _slice = createSelector(
    this._feature,
    (state): DatevWizardGetFirmaState => state.datevWizardGetFirma,
  );

  public static readonly firmenId = createSelector(
    this._slice,
    (state) => state.firmenId,
  );

  public static readonly firmenUsedInThePast = createSelector(
    this._slice,
    (state) => state.firmenUsedInThePast,
  );

  public static readonly invalidFirmenIds = createSelector(
    this._slice,
    (state) => state.invalidFirmenIds,
  );

  public static readonly selectedIdentifierType = createSelector(
    this._slice,
    (state) => state.selectedIdentifierType,
  );

  public static readonly searchResults = createSelector(
    this._slice,
    (state) => state.searchResults,
  );

  public static readonly isSearching = createSelector(
    this._slice,
    (state) => state.isSearching ?? false,
  );

  public static readonly searchError = createSelector(
    this._slice,
    (state) => state.searchError,
  );

  /**
   * Prüft ob die aktuelle firmenId invalid ist (z.B. nach fehlgeschlagenem Load)
   */
  public static readonly isCurrentFirmaInvalid = createSelector(
    this.firmenId,
    this.invalidFirmenIds,
    (firmenId, invalidIds) => {
      if (!firmenId) return false;
      return invalidIds.includes(firmenId);
    }
  );

  /**
   * Prüft ob die Firma bereits validiert wurde (entweder valid oder invalid)
   * Gibt true zurück wenn:
   * - Die Firma in invalidFirmenIds ist (invalid) ODER
   * - Die Firma in firmaEntities existiert (valid, erfolgreich geladen)
   * Gibt false zurück wenn die Firma noch geladen wird.
   */
  public static readonly isFirmaValidated = (firmenId: string | undefined) => {
    if (!firmenId) {
      return createSelector(
        this._slice,
        () => false
      );
    }

    return createSelector(
      this.invalidFirmenIds,
      FirmaEntitiesSelectors.firmaById(firmenId),
      (invalidIds, firma) => {
        // Firma ist invalid
        if (invalidIds.includes(firmenId)) return true;

        // Firma existiert in firmaEntities (wurde erfolgreich geladen)
        if (firma) return true;

        // Firma wird noch geladen
        return false;
      }
    );
  };

}
